function PressCommentaryController(){
	this.className			= "PressCommentaryController";
	this.view				= false; //"example";
	this.glob				= ["/press-commentary/"];
	this.globMain 			= true;
    this.log                = false;
    this.cache				= true;
}

PressCommentaryController.inheritsFrom( StandardController );

PressCommentaryController.prototype.on = function(onComplete){
	this.$html				= $('html');
	this.$body				= $('body');
	this.$expander     		= this.$body.find('.js-expander');
	this.$expanderContent 	= this.$body.find('.js-expander-content');
	this.$expanderLink 		= this.$expander.find('.js-expander-link');
	this.$closeLink 		= this.$expander.find('.js-close-link');
	this.$deviceType 		= this.$body.find('.js-detect-device.mobile');
	this.isMobile			= this.$deviceType.is(':visible');
	this.isDesktop 			= this.$deviceType.is(':hidden');
	this.$articles 			= $('.js-expander-content');

	this.numberOfVisibleArticles = 5;
	this.articlesGroupSetup();
	this.mobileRevealerHeight();
	// this.findMobileArticleHeight();

	this.$expanderLink.off('click touchstart').on('click touchstart', (e) => {
		if (e.cancelable) e.preventDefault(); //touchstart can't call preventDefault

		// Get last article in group
		this.numberOfVisibleArticles += 5;
		this.articlesGroupSetup();
		this.articlesGroupHeightSetup();

	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});

	this.$closeLink.off('click touchstart').on('click touchstart', (e) => {
		if (e.cancelable) e.preventDefault(); //touchstart can't call preventDefault
		this.closeContent(this.$expander);
	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});

	jstage.addListener("resize", () => this.onResize());

	return true;
};

PressCommentaryController.prototype.off = function() {
	if (this.onResize) jstage.removeListener('resize', this.onResize);
};

PressCommentaryController.prototype.articlesGroupSetup = function() {
	this.lastArticle = $(`.js-press-article:nth-child(${this.numberOfVisibleArticles})`);
	this.articlesGroupHeight = this.lastArticle.position().top + this.lastArticle.outerHeight(true);

	// Show first 5 articles
	$(`.js-press-article:lt(${this.numberOfVisibleArticles})`).each((index, element) => {
		$(element).removeClass('press-article--hidden');
	});
};

PressCommentaryController.prototype.articlesGroupHeightSetup = function() {
	this.$articles.height(this.articlesGroupHeight - 1); // remove 1px to remove slight reveal of next article group
};

PressCommentaryController.prototype.mobileRevealerHeight = function() {

	if(this.isMobile) {
		this.articlesGroupSetup();
		this.articlesGroupHeightSetup();

		// Hide articles until View more articles clicked - prevents next articles showing
		$('.js-press-article').each((index, element) => {
			if(index >= this.numberOfVisibleArticles) {
				$(element).addClass('press-article--hidden');
			}

		});
	}
	if(this.isDesktop) {
		this.$articles.css({'height': ''});

		// Show articles for Desktop
		$('.js-press-article').each((index, element) => {
			$(element).removeClass('press-article--hidden');
		});

		// reset number of articles to 5 for mobile
		this.numberOfVisibleArticles = 5;
	}
};

// PressCommentaryController.prototype.expandContent = function($elem) {
//
// 	// NEW: article reveal
// 	this.incrementalArticleShowSetup(this.currentPage + 1);
//
//
// 	const $expanderContent  = $elem.find('.js-expander-content');
// 	const revealerHeight = $expanderContent[0].scrollHeight;
//
// 	if (!$expanderContent.length) return;
//
// 	const isOpen = $elem.hasClass('expander--open');
// 	$elem.toggleClass('expander--open');
//
// 	const newHeight      = isOpen ? this.findMobileArticleHeight() : revealerHeight;
// 	console.log(newHeight, ' newHeight');
// 	$expanderContent.stop().animate({height: `${newHeight}px`}, {duration:0, easing:'linear'});
// };

// PressCommentaryController.prototype.closeContent = function($elem) {
// 	const $expanderContent  = $elem.find('.js-expander-content');
// 	const newHeight      = this.findMobileArticleHeight();
// 	console.log(newHeight, ' newHeight');
//
// 	this.$expander.removeClass('expander--open');
// 	$expanderContent.stop().animate({height: `${newHeight}px`}, {duration:0, easing:'linear'});
//
// 	$('html, body').stop().animate({ scrollTop: 0 }, 300, 'swing');
// };

PressCommentaryController.prototype.onResize = function() {
	this.isMobile =	this.$deviceType.is(':visible');
	this.isDesktop = this.$deviceType.is(':hidden');
	this.mobileRevealerHeight();
};


